import {
  CONTENT_PAGE_LOADER_DATA,
  preloadPublicContentRoute,
  publicBookingBySlugLoader,
  publicBookingLoader,
  requireCustomerAreaLoader,
  routes,
} from "@/routes";
import { readServerContentState } from "@/services/server-content-state";

import { createBrowserRouter } from "react-router";

// A server-rendered content page already holds everything it shows: the
// public layout loader is marked as hydrated so the router renders the
// page immediately instead of its loading fallback.
export const router = createBrowserRouter(
  routes,
  readServerContentState()
    ? { hydrationData: { loaderData: CONTENT_PAGE_LOADER_DATA } }
    : undefined
);

export {
  preloadPublicContentRoute,
  publicBookingBySlugLoader,
  publicBookingLoader,
  requireCustomerAreaLoader,
};
